import React, { Component, KeyboardEvent, ChangeEvent, MouseEvent } from "react";
import {
    Row, Col, Button, Modal, ModalBody, ModalHeader, ModalFooter, Spinner, UncontrolledTooltip, Badge
} from "reactstrap";
import * as KSLPlusAPI from "../services/KSLPlusAPI"

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
// @ts-ignores
import BootstrapTable from 'react-bootstrap-table-next';
// @ts-ignore
import cellEditFactory from 'react-bootstrap-table2-editor';
// @ts-ignore
import paginationFactory from 'react-bootstrap-table2-paginator';
// @ts-ignore
import  filterFactory, { selectFilter, multiSelectFilter, textFilter  } from 'react-bootstrap-table2-filter';

import { Chart } from "react-google-charts";

import { GoogleChartWrapperChartType } from "react-google-charts/dist/types";



import * as Utilities from "./Utilities"

import '../custom.css';
import { ENGINE_METHOD_PKEY_ASN1_METHS } from "constants";

import Collapse from "@kunukn/react-collapse";

type State = {    
    expanded: string[];
}

type Props = {    
    jahr: number,
    ve: KSLPlusAPI.HaushaltsEbeneDoppik,    
    settings: KSLPlusAPI.SettingsModel    
}



export class VEDoppisch extends Component<Props, State> {
    constructor(props: any) {
        super(props);
        
        
    }

    state: State = {                           
        expanded: []
    }              
    

    node: any;        
    container: any = null;

    collapsRow = (row: KSLPlusAPI.HaushaltsEbeneDoppik) => {
        this.state.expanded = this.state.expanded.filter(x => x !== row.id);
        if (row.unterEbenen)
            row.unterEbenen.forEach(r => this.collapsRow(r));


    }

    handleOnExpand = (row: KSLPlusAPI.HaushaltsEbeneDoppik, isExpand: boolean, rowIndex: number, e: any) => {
        if (isExpand) {
            this.state.expanded.push(row.id ? row.id : "");
            this.setState({ expanded: this.state.expanded })
        } else {
            this.state.expanded = this.state.expanded.filter(x => x !== row.id);
            if (row.unterEbenen)
                row.unterEbenen.forEach(r => this.collapsRow(r));
            this.setState({ expanded: this.state.expanded })
        }
    }

    createExpandRow = (rows: KSLPlusAPI.HaushaltsEbeneDoppik[]) => {
        
        return {
            renderer: (row: KSLPlusAPI.HaushaltsEbeneDoppik) => (
                <BootstrapTable hover={true} bordered={false} keyField='id' headerClasses="kslplus-hidden"  data={row.unterEbenen} columns={this.createColumns(false)} expandRow={row.unterEbenen ? this.createExpandRow(row.unterEbenen) : undefined} />

            ),
            className: 'kslplus-tabellen-expanded',
            showExpandColumn: true,
            expandColumnPosition: 'left',

            expandHeaderColumnRenderer: ({ isAnyExpands }: { isAnyExpands: boolean }) => {
                return null;
            },
            nonExpandable: rows.filter(r => !r.unterEbenen || !r.unterEbenen.length).map(d => d.id),  
            expanded: this.state.expanded,
            onExpand: this.handleOnExpand,            
            expandColumnRenderer: ({ expanded, rowKey }: { expanded: boolean, rowKey: string }) => {
                var row = rows.find(row => row.id === rowKey);
                if ((row?.unterEbenen?.length ?? 0) === 0)
                    return null;
                
                if (expanded) {
                    return (
                        <div aria-label="Zeile schließen" onKeyDown={(e) => { if (row && e.keyCode === 13) this.handleOnExpand(row, false, 0, 0); }} tabIndex={0} className="kslplus-expand-column">(-)</div>
                    );
                }
                return (
                    <div aria-label="Zeile erweitern" onKeyDown={(e) => { if (row && e.keyCode === 13) this.handleOnExpand(row, true, 0, 0); }} tabIndex={0} className="kslplus-expand-column">(+)</div>
                );
            }
        }
    }

    createColumns = (showFooter: boolean) => {
        var columns = [];


        var id = 1;
        
        
        columns.push({
            dataField: 'bezeichnung',
            text: "Bezeichnung",
            headerStyle: (colum: any, colIndex: any) => {
                return { width: '300px', textAlign: 'left' };
            },
            style: (colum: any, colIndex: any) => {
                return { width: '300px' };
            },
            formatter: (cellContent: string, row: KSLPlusAPI.HaushaltsEbeneDoppik) => {     
                //label.push(<span className="kslplus-tabellen-bezeichnung-part" id={"kslplus-label-prod" + row.id} key={"kslplus-label-" + row.id}>{Utilities.Num2Str(row.konto, row.kontoStellen) + " - " + row.bezeichnung}</span>);
                

                if (row.investNr && row.investNr !== "")
                    return (
                        <div>{Utilities.Num2Str(row.produkt, row.produktStellen) + "." + Utilities.Num2Str(row.konto, row.kontoStellen) + "-" + row.investNr + " - " + row.bezeichnung }</div>
                    );

                if (row.produktStellen)
                    return (
                        <div>{Utilities.Num2Str(row.produkt, row.produktStellen) + "." + Utilities.Num2Str(row.konto, row.kontoStellen) + " - " + row.bezeichnung}</div>
                    );

                return (                                            
                    <div>{Utilities.Num2Str(row.konto, row.kontoStellen) + " - " + row.bezeichnung}</div>
                );

            },                        
            footer: showFooter ? id++ : undefined,         
            footerFormatter: (column: any, columnIndex: number) => {
                
                return (                    
                    <div>                        
                        <div>Gesamt</div>
                    </div>
                );
            }
        });
        
        columns.push({
            dataField: 've_sol',
            text: "VE HH " + this.props.jahr.toString() + " gesamt",
            headerStyle: (colum: any, colIndex: any) => {
                return { textAlign: 'right' };
            },            
            align: 'right',
            formatter: (cellContent: string, row: KSLPlusAPI.HaushaltsEbeneDoppik) => {               
                return (
                    <div>{Utilities.FormatCurrency(row.ve_soll, 2, 3, '.', ',')}</div>
                );

            },
            style: (colum: any, colIndex: any) => {

                return { backgroundColor: this.props.settings.hFarbePJ, color: this.props.settings.vFarbePJ };
            },
            footerAlign: 'right',
            footer: showFooter ? id++ : undefined,
            footerStyle: (colum: any, colIndex: any) => {

                return { backgroundColor: this.props.settings.hFarbePJ, color: this.props.settings.vFarbePJ };
            },
            footerFormatter: (column: any, columnIndex: number) => {                
                return (
                    <div>                        
                        <div className={"kslplus-row-sum"}>{Utilities.FormatCurrency(this.props.ve.ve_soll, 2, 3, '.', ',')}</div>
                    </div>
                );
            }
        });

        if ((this.props.ve.veFj1_soll ?? 0) + (this.props.ve.veFj2_soll ?? 0) + (this.props.ve.veFj3_soll ?? 0) + (this.props.ve.veFj4_soll ?? 0) !== 0) {
            columns.push({
                dataField: 'veFj1_soll',
                text: "VE HH " + this.props.jahr.toString() + " für " + (this.props.jahr + 1).toString(),
                headerStyle: (colum: any, colIndex: any) => {
                    return { textAlign: 'right' };
                },
                align: 'right',
                formatter: (cellContent: string, row: KSLPlusAPI.HaushaltsEbeneDoppik) => {
                    return (
                        <div>{Utilities.FormatCurrency(row.veFj1_soll, 2, 3, '.', ',')}</div>
                    );

                },
                footerAlign: 'right',
                footer: showFooter ? id++ : undefined,
                footerFormatter: (column: any, columnIndex: number) => {
                    return (
                        <div>
                            <div className={"kslplus-row-sum"}>{Utilities.FormatCurrency(this.props.ve.veFj1_soll, 2, 3, '.', ',')}</div>
                        </div>
                    );
                }
            });
        }

        if ((this.props.ve.veFj2_soll ?? 0) + (this.props.ve.veFj3_soll ?? 0) + (this.props.ve.veFj4_soll ?? 0) !== 0) {
            columns.push({
                dataField: 'veFj2_soll',
                text: "VE HH " + this.props.jahr.toString() + " für " + (this.props.jahr + 2).toString(),
                headerStyle: (colum: any, colIndex: any) => {
                    return { textAlign: 'right' };
                },
                align: 'right',
                formatter: (cellContent: string, row: KSLPlusAPI.HaushaltsEbeneDoppik) => {
                    return (
                        <div>{Utilities.FormatCurrency(row.veFj2_soll, 2, 3, '.', ',')}</div>
                    );

                },
                footerAlign: 'right',
                footer: showFooter ? id++ : undefined,
                footerFormatter: (column: any, columnIndex: number) => {
                    return (
                        <div>
                            <div className={"kslplus-row-sum"}>{Utilities.FormatCurrency(this.props.ve.veFj2_soll, 2, 3, '.', ',')}</div>
                        </div>
                    );
                }
            });
        }

        if ((this.props.ve.veFj3_soll ?? 0) + (this.props.ve.veFj4_soll ?? 0) !== 0) {
            columns.push({
                dataField: 'veFj3_soll',
                text: "VE HH " + this.props.jahr.toString() + " für " + (this.props.jahr + 3).toString(),
                headerStyle: (colum: any, colIndex: any) => {
                    return { textAlign: 'right' };
                },
                align: 'right',
                formatter: (cellContent: string, row: KSLPlusAPI.HaushaltsEbeneDoppik) => {
                    return (
                        <div>{Utilities.FormatCurrency(row.veFj3_soll, 2, 3, '.', ',')}</div>
                    );

                },
                footerAlign: 'right',
                footer: showFooter ? id++ : undefined,
                footerFormatter: (column: any, columnIndex: number) => {
                    return (
                        <div>
                            <div className={"kslplus-row-sum"}>{Utilities.FormatCurrency(this.props.ve.veFj3_soll, 2, 3, '.', ',')}</div>
                        </div>
                    );
                }
            });
        }

        if (this.props.settings.doppelhaushalt && (this.props.ve.veFj4_soll ?? 0) !== 0) {
            columns.push({
                dataField: 'veFj4_soll',
                text: "VE HH " + this.props.jahr.toString() + " für " + (this.props.jahr + 4).toString(),
                headerStyle: (colum: any, colIndex: any) => {
                    return { textAlign: 'right' };
                },
                align: 'right',
                formatter: (cellContent: string, row: KSLPlusAPI.HaushaltsEbeneDoppik) => {
                    return (
                        <div>{Utilities.FormatCurrency(row.veFj4_soll, 2, 3, '.', ',')}</div>
                    );

                },
                footerAlign: 'right',
                footer: showFooter ? id++ : undefined,
                footerFormatter: (column: any, columnIndex: number) => {
                    return (
                        <div>
                            <div className={"kslplus-row-sum"}>{Utilities.FormatCurrency(this.props.ve.veFj4_soll, 2, 3, '.', ',')}</div>
                        </div>
                    );
                }
            });
        }

        if (this.props.settings.doppelhaushalt && (this.props.ve.ve1_soll??0) !== 0) {
            columns.push({
                dataField: 've1_sol',
                text: "VE HH " + (this.props.jahr+1).toString() + " gesamt",
                headerStyle: (colum: any, colIndex: any) => {
                    return { textAlign: 'right' };
                },
                align: 'right',
                formatter: (cellContent: string, row: KSLPlusAPI.HaushaltsEbeneDoppik) => {
                    return (
                        <div>{Utilities.FormatCurrency(row.ve1_soll, 2, 3, '.', ',')}</div>
                    );

                },
                style: (colum: any, colIndex: any) => {

                    return { backgroundColor: this.props.settings.hFarbePJ, color: this.props.settings.vFarbePJ };
                },
                footerAlign: 'right',
                footer: showFooter ? id++ : undefined,       
                footerStyle: (colum: any, colIndex: any) => {

                    return { backgroundColor: this.props.settings.hFarbePJ, color: this.props.settings.vFarbePJ };
                },
                footerFormatter: (column: any, columnIndex: number) => {
                    return (
                        <div>
                            <div className={"kslplus-row-sum"}>{Utilities.FormatCurrency(this.props.ve.ve1_soll, 2, 3, '.', ',')}</div>
                        </div>
                    );
                }
            });
            if ((this.props.ve.ve1Fj1_soll ?? 0) + (this.props.ve.ve1Fj2_soll ?? 0) + (this.props.ve.ve1Fj3_soll ?? 0) !== 0) {
                columns.push({
                    dataField: 've1Fj1_soll',
                    text: "VE HH " + (this.props.jahr + 1).toString() + " für " + (this.props.jahr + 2).toString(),
                    headerStyle: (colum: any, colIndex: any) => {
                        return { textAlign: 'right' };
                    },
                    align: 'right',
                    formatter: (cellContent: string, row: KSLPlusAPI.HaushaltsEbeneDoppik) => {
                        return (
                            <div>{Utilities.FormatCurrency(row.ve1Fj1_soll, 2, 3, '.', ',')}</div>
                        );

                    },
                    footerAlign: 'right',
                    footer: showFooter ? id++ : undefined,
                    footerFormatter: (column: any, columnIndex: number) => {
                        return (
                            <div>
                                <div className={"kslplus-row-sum"}>{Utilities.FormatCurrency(this.props.ve.ve1Fj1_soll, 2, 3, '.', ',')}</div>
                            </div>
                        );
                    }
                });
            }
            if ((this.props.ve.ve1Fj2_soll ?? 0) + (this.props.ve.ve1Fj3_soll ?? 0) !== 0) {
                columns.push({
                    dataField: 've1Fj2_soll',
                    text: "VE HH " + (this.props.jahr + 1).toString() + " für " + (this.props.jahr + 3).toString(),
                    headerStyle: (colum: any, colIndex: any) => {
                        return { textAlign: 'right' };
                    },
                    align: 'right',
                    formatter: (cellContent: string, row: KSLPlusAPI.HaushaltsEbeneDoppik) => {
                        return (
                            <div>{Utilities.FormatCurrency(row.ve1Fj2_soll, 2, 3, '.', ',')}</div>
                        );

                    },
                    footerAlign: 'right',
                    footer: showFooter ? id++ : undefined,
                    footerFormatter: (column: any, columnIndex: number) => {
                        return (
                            <div>
                                <div className={"kslplus-row-sum"}>{Utilities.FormatCurrency(this.props.ve.ve1Fj2_soll, 2, 3, '.', ',')}</div>
                            </div>
                        );
                    }
                });
            }
            if ((this.props.ve.ve1Fj3_soll ?? 0) !== 0) {
                columns.push({
                    dataField: 've1Fj3_soll',
                    text: "VE HH " + (this.props.jahr + 1).toString() + " für " + (this.props.jahr + 4).toString(),
                    headerStyle: (colum: any, colIndex: any) => {
                        return { textAlign: 'right' };
                    },
                    align: 'right',
                    formatter: (cellContent: string, row: KSLPlusAPI.HaushaltsEbeneDoppik) => {
                        return (
                            <div>{Utilities.FormatCurrency(row.ve1Fj3_soll, 2, 3, '.', ',')}</div>
                        );

                    },
                    footerAlign: 'right',
                    footer: showFooter ? id++ : undefined,
                    footerFormatter: (column: any, columnIndex: number) => {
                        return (
                            <div>
                                <div className={"kslplus-row-sum"}>{Utilities.FormatCurrency(this.props.ve.ve1Fj3_soll, 2, 3, '.', ',')}</div>
                            </div>
                        );
                    }
                });
            }
        }
        
        return columns;
    }
    
        
    componentDidUpdate(prevProps: Props) {                
    }

    componentDidMount() {                
    }

    render() {

        
        return (

            <div>
                <div className="kslplus-ve">                    
                    <Row>
                        <Col>
                            <BootstrapTable hover={true} bordered={true} keyField='id' data={this.props.ve.unterEbenen} columns={this.createColumns(true)} expandRow={this.createExpandRow(this.props.ve.unterEbenen??[]) } />
                        </Col>
                    </Row>


                    


                </div>
            </div>
        );
    }


    
}